/* eslint-disable @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766 */
import 'react-virtualized/styles.css';

import '@atlassian/jira-portfolio-3-common/src/css-variables/variables.css';

/* delete this import file when com.atlassian.rm.jpo.jpo3cloud.centralise-react-virtualized-overflow-styles
is cleaned up. The style rules it contains have moved to app-simple-plans/styles.css */
import './styles.css';

import '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/styles.css';

import Main from './view/main-new';

export default Main;
